import {
  ICreativeAttributes,
  ICreativeData,
  ICreativesPayload,
  ICreativesResponse,
  ICreativeResponse,
  ICreativeSyncStatusesResponse,
  ICreative
} from '@/apps/traforama/interfaces/creatives'

import apiClient from '@/utils/request'
import { serialize } from 'object-to-formdata'
import { nestedQueryFormatter } from '@/utils/query'

const CreativeToRequest = (item: ICreativeAttributes): ICreativeData => {
  const creativeData: ICreativeData = {
    ...item
  }
  creativeData.win_prices = []

  return creativeData
}

export const fetchItems = async (
  payload: ICreativesPayload
): Promise<ICreativesResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('sorter', { direction: 'asc', field: 'name' }),
    nestedQueryFormatter('filter', payload.filter, false)
  )
  const response = await apiClient.get<ICreativesResponse>('/creatives', {
    params: params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<ICreativeResponse> => {
  const response = await apiClient.get<ICreativeResponse>(`/creatives/${id}/`)
  return response.data
}

export const fetchSyncStatuses = async (
  creatureIds: string[]
): Promise<ICreativeSyncStatusesResponse> => {
  const response = await apiClient.get<ICreativeSyncStatusesResponse>(
    '/creatives/sync_status',
    {
      params: { creature_ids: creatureIds }
    }
  )
  return response.data
}

export const createItem = async (
  item: ICreativeAttributes
): Promise<ICreative> => {
  const creativeData = CreativeToRequest(item)
  const options = {
    indices: false,
    allowEmptyArrays: true
  }
  const form = serialize(creativeData, options)
  const response = await apiClient.post<ICreative>('/creatives', form)
  return response.data
}

export const updateItem = async (
  item: ICreativeAttributes
): Promise<ICreative> => {
  const creativeData = CreativeToRequest(item)
  const options = {
    indices: false,
    allowEmptyArrays: true
  }
  const form = serialize(creativeData, options)
  const response = await apiClient.put<ICreative>(`/creatives/${item.id}`, form)
  return response.data
}

export const destroyItem = async (id: string): Promise<ICreativesResponse> => {
  const response = await apiClient.delete<ICreativesResponse>(
    `/creatives/${id}`
  )
  return response.data
}

export const changeItemState = async (
  id: string,
  event: string,
  reason?: string
): Promise<ICreativeResponse> => {
  const options: Record<string, string | undefined> =
    event === 'stop'
      ? { archive_reason: reason }
      : { status_change_reason: reason }
  const response = await apiClient.post<ICreativeResponse>(
    `/creatives/${id}/${event}`,
    options
  )
  return response.data
}

export const massUpdate = async (
  ids: string[],
  action: string,
  value: any
): Promise<ICreativeResponse> => {
  const options = {
    ids: ids,
    update_action: action,
    value: value
  }
  const response = await apiClient.post<ICreativeResponse>(
    `/creatives/mass_update`,
    options
  )
  return response.data
}

export interface IReviewInfo {
  review_attempts_count: number
  status_change_reason: string | null
  report_url: string | null
}

export const fetchReviewInfo = async (id: string): Promise<IReviewInfo> => {
  const response = await apiClient.get<IReviewInfo>(
    `/creatives/${id}/review_info`
  )
  return response.data
}
